import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { recoverPassword } from "../../redux/actions/auth";
import RecuperarClave from "./RecuperarClave";

const RecuperarClaveContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = (values) => {
    dispatch(recoverPassword(values.username)).then(() => {
      navigate(`/cambiar-clave-recuperacion?usuario=${encodeURIComponent(values.username)}`);
    });
  };

  return <RecuperarClave handleSubmit={handleSubmit} />;
};

export default RecuperarClaveContainer;
